import { Component, Input, OnChanges } from '@angular/core';
import {
  ChartConfiguration,
  ChartData,
  ChartOptions,
  ChartType,
} from 'chart.js';
import { NgChartsModule } from 'ng2-charts';
import { CommonInfoTooltipComponent } from '../common-component-info-tooltip/common-component-info-tooltip.component';

@Component({
  selector: 'app-common-component-graph',
  standalone: true,
  imports: [NgChartsModule, CommonInfoTooltipComponent],
  templateUrl: './common-component-graph.component.html',
  styleUrl: './common-component-graph.component.scss',
})
export class CommonGraphComponent implements OnChanges {
  @Input() title = 'Graph';

  // Optional plain-language explanation shown via an info icon next to the title
  @Input() infoDescription = '';

  @Input() chartType: ChartType = 'bar';

  @Input() chartData!: ChartData;

  @Input() chartOptions!: ChartConfiguration['options'];

  @Input() legend = true;

  @Input() xAxisLabel = '';
  @Input() yAxisLabel = '';

  @Input() stacked = false;

  public finalChartOptions: ChartOptions = {};

  ngOnChanges() {
    this.updateOptions();
  }

  private updateOptions() {
    this.finalChartOptions = {
      ...this.chartOptions,

      responsive: true,
      maintainAspectRatio: false,

      layout: {
        padding: {
          bottom: 30,
        },
      },

      plugins: {
        ...this.chartOptions?.plugins,

        legend: {
          ...this.chartOptions?.plugins?.legend,

          display: this.legend,
          position: 'top',

          labels: {
            ...this.chartOptions?.plugins?.legend?.labels,
            usePointStyle: true,
          },
        },

        tooltip: {
          ...this.chartOptions?.plugins?.tooltip,

          mode: 'index',
          intersect: false,

          callbacks: {
            title: (tooltipItems) => tooltipItems[0]?.label || '',

            label: (context) => {
              const label = context.dataset.label || '';
              const value = context.parsed?.y ?? context.parsed ?? 0;

              return `${label}: ${Number(value).toLocaleString('en-IN')}`;
            },
          },
        },
      },

      scales:
        this.chartType === 'bar' || this.chartType === 'line'
          ? {
              x: {
                ...(this.chartOptions?.scales as any)?.x,

                stacked: this.stacked,

                ticks: {
                  ...((this.chartOptions?.scales as any)?.x?.ticks || {}),

                  display: true,
                  autoSkip: false,
                  maxRotation: 45,
                  minRotation: 0,

                  font: {
                    size: 12,
                  },
                },

                title: {
                  display: !!this.xAxisLabel,
                  text: this.xAxisLabel,
                  color: (this.chartOptions?.scales as any)?.x?.title?.color,
                },
              },

              y: {
                ...(this.chartOptions?.scales as any)?.y,

                stacked: this.stacked,
                beginAtZero: true,

                title: {
                  display: !!this.yAxisLabel,
                  text: this.yAxisLabel,
                  color: (this.chartOptions?.scales as any)?.y?.title?.color,
                },
              },
            }
          : undefined,
    };
  }
}
